import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SipViewer from './view';

const SipModule = ({ match }) => {
  return (
    <Switch>
      <Route exact path={match.url} component={SipViewer} />
    </Switch>
  );
};

export default SipModule;
